const numHackathonsList = ["0", "1", "2", "3", "4", "5", "6", "> 6"];
const numHackathons = numHackathonsList.map((v) => ({ label: v, value: v }));
export default numHackathons;
